// UNC Charlotte's undergraduate majors (#2840). Read on 2026-10-01 from the
// official 2026-2027 Undergraduate Catalog's "Academic Programs (by
// college)" page (catalog.charlotte.edu, catoid=42, navoid=5269), checked
// against its "Undergraduate Majors" A-Z list (navoid=5485; the same 184
// entries). The catalog lists each concentration as its own line ("Art,
// Painting Concentration, B.F.A."); here each major is listed once per
// degree, with the catalog's degree abbreviation (B.S.B.A., B.S.CP.E.,
// B.S.E.T., ...). Left out: minors, certificates, honors and early entry
// programs, and the two Physics B.A. plus engineering B.S. dual degrees
// (both halves are listed as majors). Artificial Intelligence, B.S. sits
// under the computing college's "Other Programs" rather than "Majors" but is
// a bachelor's program with its own catalog page, so it is kept with a note.
// "Fire and Safety Engineering Technology" is the catalog's official name.
// Flags quote the college file's art, architecture, music and aiProgram
// sources. The KB's majors list was the starting point; the catalog wins.
const majors = {
    "slug": "university-of-north-carolina-at-charlotte",
    "read": "2026-10-01",
    "intro": "Every bachelor's degree major in UNC Charlotte's official 2026-2027 Undergraduate Catalog, grouped by the college that offers it, with the degree it leads to. Concentrations are folded into their major. Minors, certificates and graduate programs are left out.",
    "groups": [
        {
            "name": "College of Arts + Architecture",
            "source": {
                "label": "UNC Charlotte 2026-2027 Undergraduate Catalog, Academic Programs (by college)",
                "url": "https://catalog.charlotte.edu/content.php?catoid=42&navoid=5269"
            },
            "majors": [
                {
                    "name": "Art",
                    "degree": "B.A.",
                    "flag": "Entrance portfolio required, due February 10, 2027.",
                    "flagSource": "art"
                },
                {
                    "name": "Art",
                    "degree": "B.F.A.",
                    "flag": "Entrance portfolio required, due February 10, 2027.",
                    "flagSource": "art"
                },
                {
                    "name": "Art History",
                    "degree": "B.A."
                },
                {
                    "name": "Dance",
                    "degree": "B.A."
                },
                {
                    "name": "Graphic Design",
                    "degree": "B.F.A.",
                    "flag": "Entrance portfolio required, due February 10, 2027.",
                    "flagSource": "art"
                },
                {
                    "name": "Music",
                    "degree": "B.A.",
                    "flag": "Entrance audition required.",
                    "flagSource": "music"
                },
                {
                    "name": "Music",
                    "degree": "B.M.",
                    "flag": "Entrance audition required.",
                    "flagSource": "music"
                },
                {
                    "name": "Theatre",
                    "degree": "B.A."
                },
                {
                    "name": "Architecture",
                    "degree": "B.A.",
                    "flag": "Secondary application to the School of Architecture, due November 15 for early action and February 15.",
                    "flagSource": "architecture"
                }
            ]
        },
        {
            "name": "College of Business",
            "source": {
                "label": "UNC Charlotte 2026-2027 Undergraduate Catalog, Academic Programs (by college)",
                "url": "https://catalog.charlotte.edu/content.php?catoid=42&navoid=5269"
            },
            "majors": [
                {
                    "name": "Accounting",
                    "degree": "B.S."
                },
                {
                    "name": "Business Administration",
                    "degree": "B.S.B.A."
                },
                {
                    "name": "Business Analytics",
                    "degree": "B.S.B.A."
                },
                {
                    "name": "Economics",
                    "degree": "B.S."
                },
                {
                    "name": "Finance",
                    "degree": "B.S.B.A."
                },
                {
                    "name": "International Business",
                    "degree": "B.S.B.A."
                },
                {
                    "name": "Management",
                    "degree": "B.S.B.A."
                },
                {
                    "name": "Management Information Systems",
                    "degree": "B.S.B.A."
                },
                {
                    "name": "Marketing",
                    "degree": "B.S.B.A."
                },
                {
                    "name": "Operations and Supply Chain Management",
                    "degree": "B.S.B.A."
                }
            ]
        },
        {
            "name": "College of Computing and Informatics",
            "source": {
                "label": "UNC Charlotte 2026-2027 Undergraduate Catalog, Academic Programs (by college)",
                "url": "https://catalog.charlotte.edu/content.php?catoid=42&navoid=5269"
            },
            "majors": [
                {
                    "name": "Computer Science",
                    "degree": "B.S."
                },
                {
                    "name": "Computer Science",
                    "degree": "B.A."
                },
                {
                    "name": "Data Science",
                    "degree": "B.S."
                },
                {
                    "name": "Sports Analytics",
                    "degree": "B.S."
                },
                {
                    "name": "Artificial Intelligence",
                    "degree": "B.S.",
                    "note": "Listed under the college's other programs in the catalog.",
                    "flag": "Competitive: minimum 2.5 GPA and SAT math 530 or ACT math 22.",
                    "flagSource": "aiProgram"
                }
            ]
        },
        {
            "name": "College of Education",
            "source": {
                "label": "UNC Charlotte 2026-2027 Undergraduate Catalog, Academic Programs (by college)",
                "url": "https://catalog.charlotte.edu/content.php?catoid=42&navoid=5269"
            },
            "majors": [
                {
                    "name": "Early Childhood Education and Intervention",
                    "degree": "B.A."
                },
                {
                    "name": "Elementary Education",
                    "degree": "B.A."
                },
                {
                    "name": "Middle Grades Education",
                    "degree": "B.A."
                },
                {
                    "name": "Special Education",
                    "degree": "B.A."
                },
                {
                    "name": "Special Education General Curriculum and Elementary Education K-6",
                    "degree": "B.A.",
                    "note": "A dual program in special education and elementary education."
                }
            ]
        },
        {
            "name": "College of Engineering",
            "source": {
                "label": "UNC Charlotte 2026-2027 Undergraduate Catalog, Academic Programs (by college)",
                "url": "https://catalog.charlotte.edu/content.php?catoid=42&navoid=5269"
            },
            "majors": [
                {
                    "name": "Civil Engineering",
                    "degree": "B.S.C.E."
                },
                {
                    "name": "Civil Engineering Technology",
                    "degree": "B.S.E.T."
                },
                {
                    "name": "Computer Engineering",
                    "degree": "B.S.CP.E."
                },
                {
                    "name": "Construction Management",
                    "degree": "B.S.C.M."
                },
                {
                    "name": "Electrical Engineering",
                    "degree": "B.S.E.E."
                },
                {
                    "name": "Electromechanical Engineering Technology",
                    "degree": "B.S.E.T."
                },
                {
                    "name": "Environmental Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Fire and Safety Engineering Technology",
                    "degree": "B.S.E.T."
                },
                {
                    "name": "Mechanical Engineering",
                    "degree": "B.S.M.E."
                },
                {
                    "name": "Mechanical Engineering Technology",
                    "degree": "B.S.E.T."
                },
                {
                    "name": "Systems Engineering",
                    "degree": "B.S.S.E."
                },
                {
                    "name": "Construction Engineering",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "College of Health and Human Services",
            "source": {
                "label": "UNC Charlotte 2026-2027 Undergraduate Catalog, Academic Programs (by college)",
                "url": "https://catalog.charlotte.edu/content.php?catoid=42&navoid=5269"
            },
            "majors": [
                {
                    "name": "Exercise Science",
                    "degree": "B.S."
                },
                {
                    "name": "Health Systems Management",
                    "degree": "B.S."
                },
                {
                    "name": "Nursing",
                    "degree": "B.S.N."
                },
                {
                    "name": "Public Health",
                    "degree": "B.S.P.H."
                },
                {
                    "name": "Respiratory Therapy",
                    "degree": "B.S.R.T."
                },
                {
                    "name": "Social Work",
                    "degree": "B.S.W."
                }
            ]
        },
        {
            "name": "College of Humanities & Earth and Social Sciences",
            "source": {
                "label": "UNC Charlotte 2026-2027 Undergraduate Catalog, Academic Programs (by college)",
                "url": "https://catalog.charlotte.edu/content.php?catoid=42&navoid=5269"
            },
            "majors": [
                {
                    "name": "Africana Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Anthropology",
                    "degree": "B.A."
                },
                {
                    "name": "Communication Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Criminal Justice",
                    "degree": "B.A."
                },
                {
                    "name": "Earth and Environmental Sciences",
                    "degree": "B.S."
                },
                {
                    "name": "English",
                    "degree": "B.A."
                },
                {
                    "name": "Environmental Studies",
                    "degree": "B.A."
                },
                {
                    "name": "French",
                    "degree": "B.A."
                },
                {
                    "name": "Geography",
                    "degree": "B.A."
                },
                {
                    "name": "Geography",
                    "degree": "B.S."
                },
                {
                    "name": "Geology",
                    "degree": "B.S."
                },
                {
                    "name": "German",
                    "degree": "B.A."
                },
                {
                    "name": "History",
                    "degree": "B.A."
                },
                {
                    "name": "Interdisciplinary Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Global Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Japanese Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Latin American Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Meteorology",
                    "degree": "B.S."
                },
                {
                    "name": "Philosophy",
                    "degree": "B.A."
                },
                {
                    "name": "Political Science",
                    "degree": "B.A."
                },
                {
                    "name": "Psychology",
                    "degree": "B.S."
                },
                {
                    "name": "Religious Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Sociology",
                    "degree": "B.A."
                },
                {
                    "name": "Spanish",
                    "degree": "B.A."
                },
                {
                    "name": "Writing",
                    "degree": "B.A."
                }
            ]
        },
        {
            "name": "College of Science",
            "source": {
                "label": "UNC Charlotte 2026-2027 Undergraduate Catalog, Academic Programs (by college)",
                "url": "https://catalog.charlotte.edu/content.php?catoid=42&navoid=5269"
            },
            "majors": [
                {
                    "name": "Biology",
                    "degree": "B.A."
                },
                {
                    "name": "Biology",
                    "degree": "B.S."
                },
                {
                    "name": "Chemistry",
                    "degree": "B.A."
                },
                {
                    "name": "Chemistry",
                    "degree": "B.S."
                },
                {
                    "name": "Mathematics",
                    "degree": "B.A."
                },
                {
                    "name": "Mathematics",
                    "degree": "B.S."
                },
                {
                    "name": "Mathematics for Business",
                    "degree": "B.A."
                },
                {
                    "name": "Mathematics for Business",
                    "degree": "B.S."
                },
                {
                    "name": "Physics",
                    "degree": "B.A."
                },
                {
                    "name": "Physics",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "School of Professional Studies",
            "source": {
                "label": "UNC Charlotte 2026-2027 Undergraduate Catalog, Academic Programs (by college)",
                "url": "https://catalog.charlotte.edu/content.php?catoid=42&navoid=5269"
            },
            "majors": [
                {
                    "name": "Professional Studies",
                    "degree": "B.S."
                }
            ]
        }
    ]
};

export default majors;
